'use client'
import { useFilterContext } from '../../../providers'
import React from 'react'
import { motion } from 'framer-motion'

export interface FiltersProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

export const Filters = ({ children }: FiltersProps): JSX.Element => {
    const { isExpanded, isInitialized } = useFilterContext()

    if (!isInitialized) return <></>

    return (
        <motion.div
            key="content"
            initial="collapsed"
            animate={children && isExpanded ? 'open' : 'collapsed'}
            exit="collapsed"
            variants={{
                open: { opacity: 1, height: 'auto', visibility: 'visible', overflow: 'visible' },
                collapsed: { opacity: 0, height: 0, visibility: 'hidden', overflow: 'hidden' },
            }}
            transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
            className="o-retain--padding-inverted border-b border-border-default bg-shade-100"
        >
            <div className="spacing-page-x border-t border-border-default flex py-6">
                <div className="flex gap-6 w-full shrink-0 flex-wrap">{children}</div>
            </div>
        </motion.div>
    )
}
